import { ENV_CHANNEL } from 'utils/constants'
import { State } from './types'

export const INITIAL_STATE: State = {
  channel: ENV_CHANNEL,
  isProduction: ENV_CHANNEL === 'prod',
}
